import StoryDetails from 'containers/StoryDetails';

const createStoryPath = (route) => ({
  ...route,
  path: [`:section(.*)/:id/${route.path}`],
});

export default [
  { component: StoryDetails, path: 'player' },
  { component: StoryDetails, path: 'details' },
].map(createStoryPath);
